import createReactClass from "create-react-class";
import React from "react";
import { ControlLabel } from "react-bootstrap";
import { ServerActions } from "../actions/serverActions";
import { TerritoryActions } from "../actions/territoryActions";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { subdivisionStore } from "../stores/subdivision";
import { territoryStore } from "../stores/territory";
import { userStore } from "../stores/user";

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {
    territoryList: territoryStore.getTerritoryList(),
    selectedTerritory: territoryStore.getSelectedTerritory(),
    subsForTerritory: subdivisionStore.getSubList(),
    userType: userStore.getSelectedRole(),
    isDispatcher: userStore.isDispatcher(),
    isDirty: restrictionRequestStore.isDirty(),
  };
}

const TerritoryView = createReactClass({
  componentDidMount: function () {
    territoryStore.subscribe(this._onChange);
    ServerActions.getTerritoryList(this.props.user?.access_token);
    userStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    territoryStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  onTerSelectChange: function (event) {
    var val = event.target.value;

    let subName = "";

    if (val === "0") {
      subName = "ALL";
    } else if (val === "1") {
      subName = "NONE";
    } else subName = val;

    if (this.state.isDirty) {
      window
        .confirm("Confirm Territory Change", {
          description:
            "Changing territories will abandon all of your current work and reset the subdivision. Are you sure you want to do this?",
          confirmLabel: "Change to " + subName,
          abortLabel: "Go Back",
        })
        .then(function () {
          TerritoryActions.territoryChanged(val);
        });
    } else {
      TerritoryActions.territoryChanged(val);
    }
  },

  //modify this to return the formBform view markup
  render: function () {
    var territories = [];
    var disableTerSelector = true;
    if (this.state.territoryList.length > 0) {
      territories = this.state.territoryList.map(function (ter, i) {
        return (
          <option key={i + 2} value={ter.name}>
            {ter.name}
          </option>
        );
      });

      territories.splice(
        0,
        0,
        <option key={1} value="1">
          None
        </option>
      );

      // if admin or super user is selected, show "NONE" option
      if (this.state.userType.indexOf(Constants.Roles.ADMIN) > -1) {
        //not a DS but has DS role available
        territories.splice(
          0,
          0,
          <option key={0} value="0">
            All
          </option>
        );
      }

      disableTerSelector = false;
    }

    var territoryList = "";
    if (this.state.userType.indexOf(Constants.Roles.DISPATCHER) > -1) {
      territoryList = (
        <div>
          <ControlLabel style={{ color: "gray" }}>DS:</ControlLabel>{" "}
          <select
            id="territorySelect"
            value={this.state.selectedTerritory}
            disabled={disableTerSelector}
            onChange={this.onTerSelectChange}
          >
            {territories}
          </select>
        </div>
      );
    }

    return territoryList;
  },
});

export default TerritoryView;
